/* eslint-disable @next/next/no-img-element */
import React from 'react'
import PaymentMethodDetails from './PaymentMethodDetails'
import ArrowUp from '../../../public/images/arrow-up-red.svg'
import ArrowDown from '../../../public/images/arrow-down-red.svg'
import Image from 'next/image'
import { Text, Header2 } from '../../styles/Components'

const ChoosePaymentDropdown = ({
  isPaymentMethodMenuVisible,
  toggleIsPaymentMethodMenuVisible,
  selectedPaymentMethod,
  selectedPaymentMethodId,
  paymentMethods,
  togglePaymentSelected,
  toggleShowAddPaymentMethod,
}) => {
  return (
    <>
      <Header2 fontSize={36} lineHeight="138%" align="center">
        Confirm your saved
        <br /> payment method
      </Header2>
      <div
        className={`payment-method-select ${isPaymentMethodMenuVisible ? 'open' : ''}`}
      >
        <button
          className="payment-method-summary"
          onClick={toggleIsPaymentMethodMenuVisible}
        >
          {selectedPaymentMethod && (
            <PaymentMethodDetails method={selectedPaymentMethod} />
          )}
          {isPaymentMethodMenuVisible ? (
            <Image src={ArrowUp} alt="arrow-up" />
          ) : (
            <Image src={ArrowDown} alt="arrow-down" />
          )}
        </button>
        <div className="menu">
          <ul
            data-testid="saved-payment-methods"
            className="saved-payment-methods"
          >
            {paymentMethods &&
              paymentMethods.map((paymentMethod, i) => (
                <li
                  className={
                    paymentMethod.id === selectedPaymentMethodId
                      ? 'selected'
                      : ''
                  }
                  key={i}
                >
                  <button
                    className="card-select"
                    onClick={() => togglePaymentSelected(paymentMethod.id)}
                  >
                    <PaymentMethodDetails method={paymentMethod} />
                  </button>
                </li>
              ))}
            <li className='add-payment-li'>
              <button
                className="add-payment-method"
                data-testid="new-payment-btn"
                id="new-payment-btn"
                type="button"
                onClick={() => {
                  toggleShowAddPaymentMethod()
                  toggleIsPaymentMethodMenuVisible()
                }}
              >
                + New Payment Method
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div className="protection">
        <img src="/images/powered_by_stripe.svg" alt="Powered by Stripe" />
        <Text fontSize={12}>Your personal information is protected.</Text>
      </div>
    </>
  )
}

export default ChoosePaymentDropdown
